import { BoltOnItem, BoltOnUniqueItem } from '../components/ui/input/DropdownInput';
import { SimManagementError } from '../models/Errors';
import { AddBoltOnPayload, LoadBoltOnsPayload, RemoveBoltOnPayload } from '../models/payload/loadRequests';
import { Provisioning } from '../models/provision';
import { Action } from './';
import {
  ENSURE_TARIFF_BOLT_ONS,
  LOAD_TARIFF_BOLT_ONS,
  LOAD_TARIFF_BOLT_ONS_FAILURE,
  LOAD_TARIFF_BOLT_ONS_PENDING,
  LOAD_TARIFF_BOLT_ONS_SUCCESS,
  SET_COMMAND_PROVISIONING,
  SIM_PROVISION_ADD_TARIFF_BOLT_ON,
  SIM_PROVISION_REMOVE_TARIFF_BOLT_ON,
} from './actionTypes';
import { ActionMeta } from './commonActions';

export function setCommandProvisioning(
  commandDefinition: string,
  provisioning: Provisioning,
): ActionMeta<string, Provisioning> {
  return {
    type: SET_COMMAND_PROVISIONING,
    payload: commandDefinition,
    meta: provisioning,
  };
}

export function addTariffBoltOn(payload: AddBoltOnPayload): Action<AddBoltOnPayload> {
  return {
    type: SIM_PROVISION_ADD_TARIFF_BOLT_ON,
    payload,
  };
}

export function removeTariffBoltOn(payload: RemoveBoltOnPayload): Action<RemoveBoltOnPayload> {
  return {
    type: SIM_PROVISION_REMOVE_TARIFF_BOLT_ON,
    payload,
  };
}

export function ensureTariffBoltOns(commandKey: string): Action<string> {
  return {
    type: ENSURE_TARIFF_BOLT_ONS,
    payload: commandKey,
  };
}

export function loadTariffBoltOnsPending(payload: LoadBoltOnsPayload): Action<LoadBoltOnsPayload> {
  return {
    type: LOAD_TARIFF_BOLT_ONS_PENDING,
    payload,
  };
}

export function loadTariffBoltOnsSuccess(
  request: LoadBoltOnsPayload,
  response: BoltOnItem[],
): ActionMeta<BoltOnItem[], LoadBoltOnsPayload> {
  return {
    type: LOAD_TARIFF_BOLT_ONS_SUCCESS,
    payload: response,
    meta: request,
  };
}

export function loadTariffBoltOnsFailure(
  request: LoadBoltOnsPayload,
  error: SimManagementError,
): ActionMeta<SimManagementError, LoadBoltOnsPayload> {
  return {
    type: LOAD_TARIFF_BOLT_ONS_FAILURE,
    payload: error,
    meta: request,
  };
}

export function loadTariffBoltOns(payload: LoadBoltOnsPayload): Action<LoadBoltOnsPayload> {
  return {
    type: LOAD_TARIFF_BOLT_ONS,
    payload,
  };
}
